import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { createGenericNameSchema } from 'utils/yupSchemas/createGenericNameSchema'

export const getCommonSchemaFields = (t: TFunction<'translation', undefined>) => {
  const accountHolderName = createGenericNameSchema(t('accountHolderName'), t, 2).required()
  const currencyCode = yup.string().label(t('currencyCode')).required()
  const description = createGenericNameSchema(t('description'), t, 2).required()
  const proofOfOwnershipDocument = yup.object().label(t('proofOfOwnership')).required()

  return {
    accountHolderName,
    currencyCode,
    description,
    proofOfOwnershipDocument,
  }
}
